import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import config from 'infra/config';

const getEnvironment = () => {
  const isProd = config.urlApi.includes("octopusic.com.br");
  const isLocalhost = config.urlApi.includes("localhost");

  if (isProd) {
    return 'production'
  } else if (isLocalhost) {
    return 'dev'
  }

  return 'staging';
}

export function init() {
  Sentry.init({
    dsn: "https://34a4e7987b014a03b0ae2d2c056df6ee@o882011.ingest.sentry.io/5917881",
    integrations: [new Integrations.BrowserTracing()],
    environment: getEnvironment(),
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    ignoreErrors: ["ResizeObserver loop limit exceeded", "ResizeObserver loop completed with undelivered notifications", "ResizeObserver loop completed with undelivered notifications."]
  });
}
